import { useOutletContext } from 'react-router-dom';
import type { Check, Location } from '@/api/types';

/**
 * What every checkout step is handed by its layout.
 *
 * Split from `CheckoutLayout` so neither file mixes a component with plain exports, which is what Fast
 * Refresh needs to reload either one cleanly — the same reason the translation context sits apart from its
 * provider.
 */
export interface CheckoutContext {
    location: Location;
    check: Check;

    /** The guest session token. Every payment call needs it, and it is not in any URL. */
    accessToken: string;
}

/**
 * The session's location and check.
 *
 * Safe to destructure without checking: `CheckoutLayout` renders loading and error screens itself and does
 * not render its children until both are present.
 */
export function useCheckout(): CheckoutContext {
    return useOutletContext<CheckoutContext>();
}
